
import { useState, useRef, useMemo } from 'react'
import { IconPlus, IconSparkles, IconTool } from '@tabler/icons-react'
import { useLocation } from 'react-router-dom'
import './styles.scss'

import { Text, Button } from '@fragments'
import Popper from "@fragments/Popper";
import CreateCommunityModal from "@components/_modals/Community/CreateCommunityModal";
import config from "@config";

import { useCommunity } from "@contexts/CommunityContext";
import { CommunityBanner } from "@components/Community";
import SidebarItem from "../_components/SidebarItem";

export default function Communities() {
    const { communities, community } = useCommunity();
    const location = useLocation();

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const popperRef = useRef(null);
    const btnRef = useRef(null);

    const currentSlug = useMemo(() => {
        const cleanPath = location.pathname.replace(/^\//, '');
        if (cleanPath) {
            const segments = cleanPath.split('/');
            const slug = segments[0];
            if (slug && !['community', 'content', 'contenthub', 'dashboard', 'banking'].includes(slug)) {
                return slug;
            }
        }
        return '';
    }, [location.pathname]);

    function handleCreateClick() {
        popperRef.current?.open(
            [
                {
                    id: 'ai',
                    label: 'Criar comunidade com I.A.',
                    icon: <IconSparkles size={16} />,
                    onClick: async () => {
                        window.open(config.communityBuilder);
                        popperRef.current?.close();
                    },
                },
                {
                    id: 'manual',
                    label: 'Criar comunidade manualmente',
                    icon: <IconTool size={16} />,
                    onClick: async () => {
                        setCreateModalOpen(true);
                        popperRef.current?.close();
                    },
                },
            ],
            'bottom-end',
            btnRef.current
        );
    }

    return (
        <div className="cs-sidebar-communities mt-4">
            <Popper controlRef={popperRef} />
            <CreateCommunityModal
                open={createModalOpen}
                onClose={() => setCreateModalOpen(false)}
            />

            <div className="cs-sidebar-section-title">
                <Text.h6
                    contrast={7}
                    grow
                    weight={400}
                    right={
                        <span ref={btnRef}>
                            <Button
                                icon={<IconPlus />}
                                size="micro"
                                tooltip="Criar comunidade"
                                color="overlay"
                                onClick={handleCreateClick}
                            />
                        </span>
                    }>
                    Comunidades
                </Text.h6>
            </div>

            <div className="cs-communities-list mt-1">
                {communities?.map((c, i) => (
                    <SidebarItem
                        key={i}
                        left={<CommunityBanner small={true} className="sidebar-item-icon" banner={c.banner} />}
                        onClick={() => community.open(c.slug)}
                        className={currentSlug === c.slug ? 'active' : ''}
                        text={c.name}
                        active={currentSlug === c.slug}
                    />
                ))}
            </div>
        </div>
    )
}

